module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/deskoffice/white.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/deskoffice/white.jpg
// module id = 555
// module chunks = 0